/* Fix collapsed product-row carousels on screens under 1024px.
 *
 * Empire's ProductRowScroller initializes Flickity with setGallerySize: false
 * and sets an explicit height only on .flickity-slider (on the theme's
 * 'heightUpdate.product-row' jQuery event). The slider is absolutely
 * positioned inside .flickity-viewport, so the viewport and the row itself
 * stay at 0 height and the cards disappear under the container's
 * overflow: hidden. Seen on "Pairs well with" (product recommendations),
 * applies to any .product-row Flickity instance.
 *
 * This shim mirrors the slider's height onto the viewport whenever the theme
 * updates it. It must use jQuery: the theme triggers the event via jQuery,
 * which native listeners cannot observe.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var $ = window.jQuery || window.$;
    if (!$) { return; }

    function mirror(row) {
      var vp = row.querySelector('.flickity-viewport');
      var slider = row.querySelector('.flickity-slider');
      if (vp && slider && slider.style.height) {
        vp.style.height = slider.style.height;
      }
    }

    // Runs after the theme's own handler (direct handlers fire before
    // delegated ones as the event bubbles), so the slider height is current.
    $(document).on('heightUpdate.product-row', '[data-product-row]', function () {
      mirror(this);
    });

    // Images loading inside a row change cell heights; the theme resizes
    // Flickity but never re-applies the slider height. Re-trigger the
    // theme's own event so both slider and viewport update.
    document.addEventListener('rimg:load', function (e) {
      var row = e.target && e.target.closest ? e.target.closest('[data-product-row]') : null;
      if (row && row.classList.contains('flickity-enabled')) {
        $(row).trigger('heightUpdate.product-row');
      }
    }, true);

    // Rows that initialized before this script ran.
    $('[data-product-row].flickity-enabled').each(function () {
      $(this).trigger('heightUpdate.product-row');
    });

    // Rows that initialize later (product recommendations arrive async).
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var t = m.target;
        if (
          m.type === 'attributes' &&
          t.nodeType === 1 &&
          t.hasAttribute('data-product-row') &&
          t.classList.contains('flickity-enabled')
        ) {
          $(t).trigger('heightUpdate.product-row');
        }
      });
    });
    mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
  });
})();
